import React from 'react';
import { STATIC_FILTERS_MAP } from 'modules/campaigns/modules/campaigns-reports/config';
import {
    FILTER_OPERATOR,
    RANGE_FILTERS_OPERATORS,
} from 'modules/campaigns/modules/campaigns-reports/config/filters/filterOperator';
import { FormattedNumber, FormattedDate } from 'modules/taboola-common-frontend-modules/i18n';

const comparableFilterValuesSeparator = '-';

const resolveValue = ({ isCurrency, isPercent, isDate, currency, value }) => {
    if (isCurrency) {
        return <FormattedNumber value={value} variant="currency" currency={currency} />;
    }
    if (isPercent) {
        return <FormattedNumber value={value / 100} maximumFractionDigits={2} variant="percent" />;
    }
    if (isDate) {
        return value ? <FormattedDate value={value} year="numeric" month="short" day="2-digit" /> : <span>-</span>;
    }
    return value;
};

export const comparableFilterValuesResolver = ({ type, values, operator, currency, availableFiltersMap }) => {
    const showSecondInput =
        operator?.value === RANGE_FILTERS_OPERATORS.BETWEEN || operator?.value === FILTER_OPERATOR.BETWEEN;
    const isCurrency = STATIC_FILTERS_MAP[type]?.isCurrency || availableFiltersMap[type]?.isCurrency;
    const isPercent = STATIC_FILTERS_MAP[type]?.isPercent || availableFiltersMap[type]?.isPercent;
    const isDate = STATIC_FILTERS_MAP[type]?.isDate || availableFiltersMap[type]?.isDate;
    const comparableFilterFirstValue = resolveValue({ isCurrency, isPercent, isDate, currency, value: values[0] });
    const comparableFilterSecondValue = resolveValue({ isCurrency, isPercent, isDate, currency, value: values[1] });

    return !showSecondInput
        ? comparableFilterFirstValue
        : [comparableFilterFirstValue, comparableFilterValuesSeparator, comparableFilterSecondValue];
};
